// src/utils/featureGate.js
import MoksyLogger from './logger'; // 👈 THIS WAS MISSING

/**
 * @function isFeatureEnabled
 * @description 
 * Bulletproof gate for platform orchestration. 
 * If flags are missing, it defaults to FALSE (Zero-Trust) and logs the mismatch.
 * 
 * Standard 7: Security & Supply-Chain Protection
 * Standard 12: Observability & Debuggability
 */
export const isFeatureEnabled = (flags, key) => {
  // 🛡️ Safety: If the flag set is invalid, deny access by default
  if (!flags || typeof flags !== 'object') return false;
  
  const status = flags[key];
  
  if (status === undefined) {
    /**
     * 🔍 Standard 12: Observability
     * Report that a component is asking for a flag that doesn't exist 
     * in the currently loaded dictionary.
     */
    MoksyLogger.log('MISSING_FEATURE_FLAG', { 
      key, 
      resolution: 'Access Denied (Default)' 
    }, 'warn');
    
    return false;
  }
  
  // Explicitly check for true (prevents truthy/falsy bugs)
  return status === true;
};